import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {ActivatedRoute, Router} from "@angular/router";
import { Subject } from "rxjs";

import { environment } from "../../environments/environment";
import { AuthData } from "./auth-data.model";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import { MessageService } from "../@pages/components/message/message.service";
import {
  IntAccountAs,
  IntAccountInd,
  IntMessagePop,
  IntParam,
} from "../common/anti-theft-table";
import { BsModalService } from "ngx-bootstrap";
import { ChangePasswordDialogComponent } from "../dialogs/change-password/change-password-dialog.component";
import {
  logintTypeCorpo,
  logintTypeInd,
  modalConfigIgnorBack,
} from "../common/constant";
import {
  findObjectIndexInArray,
  padLeft,
  translateTableMessages,
  verIfNotNullOrUndefined,
} from "../common/common";
import { SimpleCrypt } from "ngx-simple-crypt";
import { TermsDialogComponent } from "../dialogs/terms/terms-dialog.component";
import * as XLSX from "xlsx";
import { Title } from "@angular/platform-browser";
import { UserIdleService } from "angular-user-idle";

const BACKEND_URL = environment.apiUrl + "/user";

@Injectable()
export class AuthService {
  private isAuthenticated = false;
  public token: string;
  private tokenTimer: any;
  private userId: string;
  public userData;
  public userDataAs: IntAccountAs;
  private userLang: string = environment.defaultLang;
  public userLangNext = new Subject<any>();
  public registeData;
  private configParamasHelp: IntParam[] = [];
  private cryptr = new SimpleCrypt();
  public isMobileNav: boolean = false;
  public indTagReg: string = "";
  public linePerPage: number = 10;

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private _notification: MessageService,
    private modalService: BsModalService,
    private titleSrv: Title,
    private userIdle: UserIdleService
  ) {
    // this language will be used as a fallback when a translation isn't found in the current language

    const self = this;
    translate.onLangChange.subscribe((event: LangChangeEvent) => {
      self.userLangNext.next(event.lang);

      self.langSelectedSave(event.lang);
      translateTableMessages(self.translate);
    });
    this.linePerGageLoad();

    // Start watching when user idle is starting.
    this.userIdle.onTimerStart().subscribe((count) => {
      // console.log(count);
    });

    // Start watch when time is up.
    this.userIdle.onTimeout().subscribe(() => {
      // console.log("Time is up!");
      self.logout();
    });
  }

  updatePageTitle(extraText: string, replaceAll: boolean = false) {
    let after = "";
    if (!replaceAll) {
      if (extraText) {
        after += " - ";
      }
      after += this.translate.instant("PageTitle1");
    }
    this.titleSrv.setTitle(extraText + after);
  }
  goToLogin() {
    this.router.navigate(["/session/login"]);
  }
  getToken() {
    return this.token;
  }

  getIsAuth() {
    return this.isAuthenticated;
  }

  getUserId(isToDisplay: boolean = false) {
    if (isToDisplay) {
      try {
        if (this.userData.type === logintTypeCorpo) {
          return this.userId;
        } else {
          return "";
        }
      } catch (e) {
        return "";
      }
    } else {
      return this.userId;
    }
  }

  linePerGageSave() {
    localStorage.setItem("linePP", this.linePerPage + "");
  }
  linePerGageLoad() {
    let lppTemp = localStorage.getItem("linePP");
    try {
      let lppTempN = parseInt(lppTemp);
      if (lppTempN > 10) {
        this.linePerPage = lppTempN;
      } else this.linePerPage = 10;
    } catch (e) {
      this.linePerPage = 10;
    }
  }

  getUserIdAs(isToDisplay: boolean = false) {
    //console.log("isToDisplay", isToDisplay);
    if (isToDisplay) {
      if (this.userDataAs && this.userDataAs !== null) {
        return this.userDataAs.client;
      } else if (this.userData.type === logintTypeCorpo) {
        return this.userId;
      } else {
        return "";
      }
    } else {
      /*console.log("getUserIdAs", [
        this.userDataAs,
        this.userId,
        this.token,
        this.userData,
        this.userDataAs
      ]);*/

      if (this.userDataAs && this.userDataAs != null)
        return this.userDataAs.client;
      return this.userId;
    }
  }

  isAdminU() {
    try {
      return this.userData.mu === true;
    } catch (e) {
      return false;
    }
  }

  isCorpAdminU() {
    try {
      return (
        this.userData.type === logintTypeCorpo && this.userData.oa === false
      );
    } catch (e) {
      return false;
    }
  }

  getUserEmail() {
    try {
      return this.userData.email;
    } catch (e) {
      return null;
    }
  }

  getUserProfilePic() {
    function defaultPic() {
      return "assets/img/profiles/default-profile.png";
    }
    try {
      if (this.userData.photo) {
        return this.userData.photo;
      } else return defaultPic();
    } catch (e) {
      return defaultPic();
    }
  }

  getAuthStatusListener() {
    // return this.authStatusListener.asObservable();
  }

  createUser(
    email: string,
    password: string,
    firstName: string,
    lastName: string
  ) {
    // const authData: AuthData = { email: email, password: password, firstName: firstName, lastName: lastName };
    // this.http.post(BACKEND_URL + '/signup', authData).subscribe(
    //     () => {
    //         this.goToLogin();
    //
    //     },
    //     error => {
    //         this.authStatusListener.next(false);
    //     }
    // );
  }

  login(email: string, password: string, loginType: string, mfaToken: string) {
    const authData: AuthData = {
      email: email,
      password: password,
      loginType: loginType,
      mfaToken: mfaToken,
    };

    return this.http.post<{
      token: string;
      expiresIn: number;
      userId: string;
      userData;
      status: number;
      messageId: string;
      email: string;
      dataReturn: any;
    }>(BACKEND_URL + "/login", authData);
  }

  resendMFA(email: string, password: string, loginType: string) {
    return this.http.post<{
      success: boolean;
      messageId: string;
      email: string;
    }>(BACKEND_URL + "/resendMFA", {
      email: email,
      password: password,
      loginType: loginType,
    });
  }

  userUpdateAccess(
    expiresIn,
    userId,
    userData,
    token,
    isOAuth,
    isRefreshToken?
  ) {
    /*console.log("userUpdateAccess", 
    {
      expiresIn,
      userId,
      userData,
      token,
      isOAuth,
      isRefreshToken
    });*/

    const expiresInDuration = expiresIn;

    if (expiresIn) {
      this.setAuthTimer(expiresInDuration);
    }
    this.isAuthenticated = true;
    this.userId = userId;
    if (!isRefreshToken) {
      this.userData = userData;
    }
    // this.authStatusListener.next(true);
    const now = new Date();
    const expirationDate = new Date(now.getTime() + expiresInDuration * 1000);

    this.saveAuthData(token, expirationDate, this.userId, this.userData);
    if (isOAuth) {
      this.autoAuthUser();
      this.validToken();
    }

    if (!isRefreshToken) {
      if (this.userData.type === logintTypeCorpo) {
        this.router.navigate(["/tag/corp/list"]);
      } else if (this.userData.type === logintTypeInd) {
        this.router.navigate(["/tag/ind/profile"]);
      }
    }
    try {
      this.startWatching();
    } catch (e) {
      console.log(e);
    }
  }

  autoAuthUser() {
    const authInformation = this.getAuthData();
    if (!authInformation) {
      return;
    }
    const now = new Date();
    const expiresIn = authInformation.expirationDate.getTime() - now.getTime();
    if (expiresIn > 0) {
      this.token = authInformation.token;
      this.isAuthenticated = true;
      this.userId = authInformation.userId;
      this.userData = authInformation.userData;

      this.setAuthTimer(expiresIn / 1000);

      // this.authStatusListener.next(true);
    }
  }

  validToken() {
    this.http.post<{ valid: string }>(BACKEND_URL + "/vt", null).subscribe(
      (response) => {
        if (response.valid) {
        } else {
          this.logout();
        }
      },
      (error) => {
        this.logout();
        // this.authStatusListener.next(false);
      }
    );
  }

  logout() {
    const self = this;
    function completeLogout() {
      try {
        clearTimeout(self.tokenTimer);
      } catch (e) {}
      self.token = "";
      self.userId = "";
      self.userData = null;
      self.isAuthenticated = false;
      // self.authStatusListener.next(false);
      self.logoutAs();
      self.clearAuthData();
      self.goToLogin();
    }

    this.http.post<{ logout: string }>(BACKEND_URL + "/logout", null).subscribe(
      (response) => {
        completeLogout();
        // const logout = response.logout;
        // if (logout) {
        //
        // }
      },
      (error) => {
        completeLogout();
        // this.authStatusListener.next(false);
      }
    );
    this.stop();
    this.stopWatching();
  }

  logoutAs(goToList: boolean = false) {
    let add = this.goToHomeAdd();
    this.userDataAs = null;
    this.saveAuthDataAs();
    if (goToList) {
      this.router.navigate([add]);
    }
  }

  goToHome() {
    let add = this.goToHomeAdd();
    this.router.navigate([add]);
  }

  goToHomeAdd() {
    // console.log("this.userDataAs", this.userData);
    if (this.userData) {
      var isCorp = false;
      try {
        isCorp = this.userData.type == "COR";
      } catch (e) {}

      if (isCorp) {
        return "/tag/corp/list";
      } else {
        return "/tag/ind/profile";
      }
    } else return "";
  }
  private refreshToken() {
    this.http
      .post<{ token: string; expiresIn: number; userId: string; userData }>(
        BACKEND_URL + "/refreshToken",
        null
      )
      .subscribe(
        (response) => {
          const token = response.token;
          this.token = token;
          if (token) {
            this.userUpdateAccess(
              response.expiresIn,
              response.userId,
              response.userData,
              token,
              false,
              true
            );
          } else {
            this.logout();
          }
        },
        (error) => {
          // this.authStatusListener.next(false);
          this.logout();
        }
      );
  }

  private setAuthTimer(duration: number) {
    this.tokenTimer = setTimeout(() => {
      this.refreshToken();
      // this.logout();
    }, duration * 1000 - 120 * 1000);
  }

  private verUserID(userId: string, userData) {
    userId = userId + "";

    if (userId.length < 10 && userData.type === logintTypeInd) {
      const tempU = padLeft(userId, 10, " ");

      return tempU;
    } else {
      return userId;
    }
  }
  private saveAuthData(
    token: string,
    expirationDate: Date,
    userId: string,
    userData
  ) {
    this.token = token;
    localStorage.setItem(
      "token",
      this.cryptr.encode(environment.googleRecaptcha, token)
    );
    localStorage.setItem(
      "expiration",
      this.cryptr.encode(
        environment.googleRecaptcha,
        expirationDate.toISOString()
      )
    );
    localStorage.setItem(
      "userId",
      this.cryptr.encode(
        environment.googleRecaptcha,
        this.verUserID(userId, userData)
      )
    );
    localStorage.setItem(
      "userData",
      this.cryptr.encode(environment.googleRecaptcha, JSON.stringify(userData))
    );
    this.saveAuthDataAs();
  }

  private saveAuthDataAs() {
    if (this.userDataAs && this.userDataAs !== null) {
      localStorage.setItem(
        "userDataAs",
        this.cryptr.encode(
          environment.googleRecaptcha,
          JSON.stringify(this.userDataAs)
        )
      );
    } else {
      localStorage.removeItem("userDataAs");
    }
  }

  private clearAuthData() {
    localStorage.removeItem("token");
    localStorage.removeItem("expiration");
    localStorage.removeItem("userId");
    localStorage.removeItem("userData");
    localStorage.removeItem("userDataAs");
  }

  private getAuthData() {
    let token = localStorage.getItem("token");
    if (verIfNotNullOrUndefined(token) && token !== "") {
      token = this.cryptr.decode(environment.googleRecaptcha, token);
    }
    let expirationDate = localStorage.getItem("expiration");
    if (verIfNotNullOrUndefined(expirationDate) && expirationDate !== "") {
      expirationDate = this.cryptr.decode(
        environment.googleRecaptcha,
        expirationDate
      );
    }

    let userData = localStorage.getItem("userData");
    let userDataAs = localStorage.getItem("userDataAs");

    if (verIfNotNullOrUndefined(userData) && userData !== "") {
      try {
        userData = JSON.parse(
          this.cryptr.decode(environment.googleRecaptcha, userData)
        );
      } catch (e) {}
    }
    this.langSelectedLoad();
    if (verIfNotNullOrUndefined(userDataAs) && userDataAs !== "") {
      try {
        this.userDataAs = JSON.parse(
          this.cryptr.decode(environment.googleRecaptcha, userDataAs)
        );
        this.updatePageTitle(
          this.userDataAs.client + " " + this.userDataAs.name
        );
      } catch (e) {}
    }
    let userId = localStorage.getItem("userId");

    if (verIfNotNullOrUndefined(userId) && userId !== "") {
      userId = this.cryptr.decode(environment.googleRecaptcha, userId);
      userId = userId.trim();
    }

    if (!token || !expirationDate) {
      return;
    }
    this.startWatching();
    this.restart();
    return {
      token: token,
      expirationDate: new Date(expirationDate),
      userId: userId,
      userData: userData,
    };
  }

  langSelectedValidate(lang: string) {
    const langList = ["en", "fr", "es"];
    if (lang) {
      lang = lang.toLowerCase();
    }

    if (langList.indexOf(lang) === -1) {
      return environment.defaultLang;
    } else {
      return lang;
    }
  }
  langSelectedChange(lang: string) {
    lang = this.langSelectedValidate(lang);
    lang = lang.toLowerCase();

    this.translate.use(lang);

    const self = this;

    self.langSelectedSave(lang);
    self.userLang = this.langSelectedValidate(lang);
  }

  langSelectedSave(lang: string) {
    localStorage.setItem(
      "pageLang",
      this.cryptr.encode(environment.googleRecaptcha, lang.toLowerCase())
    );
  }

  langSelectedLoad() {
    let lang = localStorage.getItem("pageLang");
    if (lang) {
      lang = this.cryptr.decode(environment.googleRecaptcha, lang);
    }
    this.userLang = this.langSelectedValidate(lang);
    this.langSelectedChange(this.userLang);
  }

  getUserLang() {
    return this.userLang.toLowerCase();
  }

  // messageTxt:string, color? :string='danger', position :string='top-right', style:string="flip", duration:string?=0){
  messageSaveRecord(messageId?: string, messageParams?: object) {
    const msg: IntMessagePop = <IntMessagePop>{};

    if (messageId) {
      if (messageParams) {
        msg.messageTxt = this.translate.instant(messageId, messageParams);
        // msg.messageTxt = this.translate.instant(messageId);
      } else {
        msg.messageTxt = this.translate.instant(messageId);
      }
    } else {
      msg.messageTxt = this.translate.instant("591");
    }
    msg.color = "success";
    msg.duration = 2500;
    return msg;
  }

  showMessagePop(options: IntMessagePop) {
    // if (!options.color) {
    //     options.color = 'danger';
    // }
    if (!options.color) {
      options.color = "success";
    }
    if (!options.position) {
      options.position = "top-right";
    }
    if (!options.style) {
      options.style = "flip";
    }
    if (!options.duration) {
      options.duration = 0;
    }

    this._notification.create(options.color, options.messageTxt, {
      Position: options.position,
      Style: options.style,
      Duration: options.duration,
    });
  }

  changeAccountPassword(data) {
    const self = this;
    this.showPasswordChangeDlg(data);
  }

  showPasswordChangeDlg(data) {
    const self = this;
    function show() {
      const initialState = { data: data };
      let bsModalRef = self.modalService.show(
        ChangePasswordDialogComponent,
        Object.assign({}, modalConfigIgnorBack, {
          class: "modal-md",
          initialState,
        })
      );
      bsModalRef.content.action.subscribe((value) => {
        if (value.valid && value.pass) {
          data.aData["pass"] = value.pass;
          self.updateUserPass(data).subscribe((postData) => {
            self.showMessagePop(self.messageSaveRecord("142"));
          });
        }
      });
    }
    show();
  }

  updateUserPass(data) {
    return this.http.patch<{
      message: string;
      messageId: string;
      extra: object;
    }>(environment.apiUrl + "/user/pu/" + data.account, data);
  }

  createHistLog(
    iActionCode: number,
    iTagID: number,
    iTagState: number,
    sDescr: string
  ) {
    try {
      let data = {
        client_code: this.getUserIdAs(),
        client_type: this.isUserDataAs()
          ? this.userDataAs.CORP
            ? "COR"
            : "IND"
          : this.userData.type,
        name: this.userData.name,
        email: this.getUserEmail(),
        action_code: iActionCode,
        descr: sDescr,
        tag_auto_id: iTagID,
        is_master: false,
      };

      if (this.userData.mu) {
        if (this.userData.mu === true) {
          data.is_master = true;
        }
      }
      if (iTagID > 0) {
        data["tag_state"] = iTagState;
      }

      return data;
    } catch (e) {
      console.log("hist err", e);
    }
  }

  indRegister(account: IntAccountInd) {
    return this.http.post<{
      token: string;
      expiresIn: number;
      userId: string;
      userData;
    }>(BACKEND_URL + "/ind/reg", { regData: account });
  }

  setUserAs(account) {
    this.userDataAs = account as IntAccountAs;
    this.updatePageTitle(this.userDataAs.client + " " + this.userDataAs.name);
    this.saveAuthDataAs();
  }

  clearUserAs() {
    this.updatePageTitle("");
    this.userDataAs = null;
  }

  isUserDataAs() {
    if (this.userDataAs && this.userDataAs !== null) {
      return true;
    } else {
      return false;
    }
  }

  isValidFileExt(filename: string, validExt: string[]) {
    const fileSplit = filename.toLowerCase().split(".");

    if (
      fileSplit.length > 0 &&
      validExt.indexOf(fileSplit[fileSplit.length - 1]) != -1
    ) {
      return true;
    } else {
      for (let ext of validExt) {
        ext = "." + ext;
      }
      this.showMessagePop(
        Object.assign(
          this.messageSaveRecord("571", {
            file: '"' + filename + '"',
            extensions: validExt.join(", "),
          }),
          { duration: 6000, color: "danger" }
        )
      );
      return false;
    }
  }

  isValidFileSize(filename: string, size: number, maxSize: number = 2) {
    const fileSplit = filename.toLowerCase().split(".");

    if (size / 1024 / 1024 <= maxSize) {
      return true;
    } else {
      this.showMessagePop(
        Object.assign(
          this.messageSaveRecord("570", {
            file: '"' + filename + '"',
            sizeLimit: maxSize,
          }),
          { duration: 6000, color: "danger" }
        )
      );
      return false;
    }
  }

  getConfigParam() {
    return this.http.get<{
      message: string;
      params: IntParam[];
    }>(environment.apiUrl + "/param/params?" + "type=help");
  }
  getHelpDocList() {
    const self = this;
    const lang = this.getUserLang();
    this.getConfigParam().subscribe((postData) => {
      try {
        self.configParamasHelp = postData.params;
        const i = findObjectIndexInArray(
          self.configParamasHelp,
          "param_name",
          "HELP_FILE_" + lang.toUpperCase()
        );
        if (i > -1) {
          window.open(
            environment.apiUrlInterceptVer +
              "/help/" +
              self.configParamasHelp[i].param_value,
            "_blank"
          );
        }
      } catch (e) {}
    });
  }

  showTermsDlg(code: string) {
    var code = code + "_" + this.getUserLang().toUpperCase();
    var title = "";
    if (code == "TERMS") {
      title = "P_terms";
    } else if (code == "PRIVACY") {
      title = "P_privacy";
    }

    const self = this;
    function show() {
      const initialState = { data: { title: title, code: code } };
      // modal-md
      let bsModalRef = self.modalService.show(
        TermsDialogComponent,
        Object.assign({}, modalConfigIgnorBack, {
          class: "modal-Terms",
          initialState,
        })
      );
      // bsModalRef.content.action.subscribe((value) => {
      //     if ((value.valid) && (value.pass)) {
      //         data.aData['pass'] = value.pass;
      //         self.updateUserPass(data).subscribe(postData => {
      //             self.showMessagePop(self.messageSaveRecord("142"));
      //
      //         });
      //
      //     }
      // });
    }
    show();
  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };
    XLSX.writeFile(workbook, this.toExportFileName(excelFileName));
  }

  public exportAsMultTableExcelFile(
    tables: any[],
    excelFileName: string
  ): void {
    // const workbooks: XLSX.WorkBook[];
    // for (let table of tables) {
    //   const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(table.exportRows);
    //   const workbook: XLSX.WorkBook = {
    //     Sheets: {data: worksheet},
    //     SheetNames: ["data"]
    //   }
    //   workbooks.push( workbook);
    // }
    // XLSX.writeFile(workbooks, this.toExportFileName(excelFileName));

    var wb = XLSX.utils.book_new();

    if (tables && Array.isArray(tables)) {
      // console.log("is array TABLES");
      for (let table of tables) {
        // console.log("table", table);
        if (
          table &&
          table.exportRows &&
          Array.isArray(table.exportRows) &&
          table.exportRows.length > 0
        ) {
          var ws = XLSX.utils.json_to_sheet(table.exportRows);

          // console.log("sheet");
          XLSX.utils.book_append_sheet(wb, ws, table.sheet);
          // console.log("sheet app");
        }
      }

      //create and downloading workbook
      XLSX.writeFile(wb, excelFileName);
    } else {
      console.log("invalid tables ", tables);
    }
  }

  toExportFileName(excelFileName: string): string {
    return `${excelFileName}_export_${new Date().getTime()}.xlsx`;
  }

  exportToExcelTables(tables, filename) {
    for (let tableRow of tables) {
      if (tableRow.table) {
        let exportRows = [];
        let tempCopList = [];
        for (let col of tableRow.columns) {
          if (col.prop) {
            let temCol = {};
            temCol["prop"] = col.prop;
            temCol["label"] = this.translate.instant(col.name);
            tempCopList.push(temCol);
          }
        }
        // console.log("tableRow.table", tableRow.table);
        for (let dataRow of tableRow.table) {
          let newRow = {};
          for (let col of tableRow.columns) {
            if (col.prop) {
              let indexCOl = findObjectIndexInArray(
                tempCopList,
                "prop",
                col.prop
              );
              if (indexCOl != -1) {
                newRow[`${tempCopList[indexCOl]["label"]}`] = dataRow[col.prop];
              }
            }
          }
          exportRows.push(newRow);
        }
        tableRow["exportRows"] = exportRows;
        // console.log(this.admSrv.corpList);
      }
    }
    // console.log("exportToExcelTables", tables);

    this.exportAsMultTableExcelFile(tables, this.toExportFileName(filename));
  }

  updatePrintSetting(landscape, document) {
    // console.log("#updatePrintSetting");
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    style.media = "print";

    // console.log(style);

    // style.appendChild(
    //   document.createTextNode(
    //     landscape
    //       ? `@page { size: ${(11 * 12) /
    //           8.5}in 12in ; margin: 1cm; margin-top: 0cm;}`
    //       : `@page { size: 12in ${(11 * 12) /
    //           8.5}in;  margin: 1cm; margin-top: 0cm;}`
    //   )
    // );
    style.appendChild(
      document.createTextNode(
        landscape
          ? `@page { size: 11in 8.5in ; margin-top: 0cm; }`
          : `@page { size: 8.5in 11in ;  margin-top: 0cm; }`
        // `@page { size: A4 ;  margin-top: 0cm; margin-left: 1cm; margin-right: 1.2cm;}`
      )
    );

    // style.appendChild(
    //   document.createTextNode(
    //     landscape
    //       ? `@page { size: ${(11 * 12) / 8.5}in 12in ; margin-top: 0cm;}`
    //       : `@page { size: 12in ${(11 * 12) / 8.5}in;  margin-top: 0cm;}`
    //   )
    // );

    head.appendChild(style);
  }

  stop() {
    this.userIdle.stopTimer();
  }

  stopWatching() {
    // console.log("stopWatching");
    this.userIdle.stopWatching();
  }

  startWatching() {
    // console.log("startWatching");
    this.userIdle.startWatching();
  }

  restart() {
    this.userIdle.resetTimer();
  }

  getParam(paramName) {
    return this.http.get<{
      message: string;
      value: string;
    }>(environment.apiUrl + "/param/param-clist?" + "paramName=" + paramName);
  }
}
